import { ThemeProvider as MuiThemeProvider } from '@mui/material/styles';

export const ThemeProvider = MuiThemeProvider;
